import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/hold-expired-toast-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageCarousel"] */ "/vercel/path0/apps/web/src/components/ui/image-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductGrid"] */ "/vercel/path0/apps/web/src/modules/products/components/product-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_react-dom@19.0.0_react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
